export const INVERSE_CALC_ENABLED_STORAGE_KEY = 'InverseCalcEnabled';

export const enableInverseCalculation = () =>
  window.localStorage.setItem(INVERSE_CALC_ENABLED_STORAGE_KEY, 'true');

export const isInverseCalculationEnabled = () =>
  window.localStorage.getItem(INVERSE_CALC_ENABLED_STORAGE_KEY) === 'true';
